import React, { useEffect, useState } from "react";
import CreateProgramTemplate from "../createProgramTemplate/CreateProgramTemplate";
import { useParams } from "react-router-dom";
import { useGetProgramTemplateById } from "../../api/services/programTemplate/programTemplateApis";
import { useDispatch } from "react-redux";
import {
  toggleLoader,
  toggleToast,
} from "../../redux/slices/appState/appStateSlice";
import { getValueOrBlank, isNotEmpty } from "../../helpers/utils";
import {
  ProgramTemplateFormKey,
  ProgramTemplateProfileFormProps,
} from "../createProgramTemplate/modelsAndSchemas/Models";
import { useSiteCore } from "../../hooks/useSiteCore";
import { CountriesData } from "../viewProgramTemplate/modelsAndSchemas/Models";
import { createProgramSiteCoreKeys } from "../createProgramTemplate/siteCore/SiteCoreKeys";

export const pageId = "edit-program-template";

const EditProgramTemplate = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { commonLabels } = useSiteCore();
  const [programTemplateValues, setProgramTemplateValues] =
    useState<ProgramTemplateProfileFormProps>();
  const {
    mutateAsync: getProgramTemplateById,
    data: programTemplateData,
    isPending,
    isError: isProgramTemplateError,
  } = useGetProgramTemplateById();

  useEffect(() => {
    if (id) {
      getProgramTemplateById(id);
    }
  }, [id]);

  useEffect(() => {
    dispatch(
      toggleLoader({
        isVisible: isPending,
      }),
    );
    return () => {
      dispatch(toggleLoader({ isVisible: false }));
    };
  }, [isPending]);

  useEffect(() => {
    if (isProgramTemplateError) {
      dispatch(
        toggleToast({
          open: true,
          message: commonLabels.someThingWentWrongPleaseTryAgainLater,
          type: "error",
        }),
      );
      dispatch(toggleLoader({ isVisible: false }));
    }
  }, [isProgramTemplateError]);

  useEffect(() => {
    if (isNotEmpty(programTemplateData)) {
      const countriesData = programTemplateData?.countries?.map(
        (country: CountriesData) => country.countryId,
      );
      const defaultValues = {
        [ProgramTemplateFormKey.programName]: getValueOrBlank(
          programTemplateData?.name,
        ),
        [ProgramTemplateFormKey.lineOfBusiness]: getValueOrBlank(
          programTemplateData?.lineOfBusinessId,
        ),
        [ProgramTemplateFormKey.programFrameWork]: getValueOrBlank(
          programTemplateData?.programFrameWorkId,
        ),
        [ProgramTemplateFormKey.solutionCategory]: getValueOrBlank(
          programTemplateData?.solutionCategoryId,
        ),
        [ProgramTemplateFormKey.solutionCategoryLob]: getValueOrBlank(
          programTemplateData?.solutionCategoryLobid,
        ),
        [ProgramTemplateFormKey.solutionOffering]: getValueOrBlank(
          programTemplateData?.solutionOfferingsId,
        ),
        [ProgramTemplateFormKey.programClass]: getValueOrBlank(
          programTemplateData?.programClassId,
        ),

        [ProgramTemplateFormKey.duration]:
          programTemplateData?.durationInMonths ?? undefined,
        [ProgramTemplateFormKey.status]: getValueOrBlank(
          programTemplateData?.status,
        ),
        [ProgramTemplateFormKey.country]: countriesData,
        [ProgramTemplateFormKey.programNameByLanguage]: "",
        [ProgramTemplateFormKey.localizedProgramTemplateNames]:
          programTemplateData?.localizedProgramTemplateNames ?? [],
        [ProgramTemplateFormKey.activities]:
          programTemplateData?.activities ?? [],
        [ProgramTemplateFormKey.closingReasonType]: getValueOrBlank(
          programTemplateData?.closingReason,
        ),
        [ProgramTemplateFormKey.nextAccess]: programTemplateData?.nextAccess
          ? createProgramSiteCoreKeys?.nextAccessYes
          : createProgramSiteCoreKeys?.nextAccessNo,
        [ProgramTemplateFormKey.selectRegionType]: countriesData.length
          ? createProgramSiteCoreKeys.multipleCountries
          : createProgramSiteCoreKeys.regionTypeGlobal,
      };
      setProgramTemplateValues(defaultValues);
    }
  }, [programTemplateData]);

  return (
    <CreateProgramTemplate
      pageId={pageId}
      isEditTemplate={true}
      templateId={id}
      editProgramTemplateData={programTemplateValues}
    />
  );
};
export default EditProgramTemplate;
